import script from "./SceneCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SceneCard.vue?vue&type=script&setup=true&lang=ts"

import "./SceneCard.vue?vue&type=style&index=0&id=aa569b5e&lang=css"

const __exports__ = script;

export default __exports__